import React, { useEffect } from "react";
import { ReactSVG } from "react-svg";
import { Link, useNavigate } from "react-router-dom"



const Footer = () => {
    const navigate = useNavigate();
    const footerList = [
        {
            title: '關於RevX',
            item: [
                {
                    title: '方案價格',
                    path: '/pricing'
                }, {
                    title: '使用手冊',
                    path: 'https://revx.gitbook.io/guide-book/',
                }, {
                    title: '付款方式',
                    path: '/pay',
                }
            ]
        }, {
            title: '條款',
            item: [
                {
                    title: '回饋計畫',
                    path: 'https://revx.gitbook.io/guide-book/revx-hui-kui-ji-hua'
                }, {
                    title: '會員條款',
                    path: 'https://revx.gitbook.io/guide-book/hui-yuan-tiao-kuan'
                }, {
                    title: '訂閱與取消條款',
                    path: 'https://revx.gitbook.io/guide-book/revx-ding-yue-he-qu-xiao-tiao-kuan'
                }, {
                    title: '使用者條款',
                    path: 'https://revx.gitbook.io/guide-book/shi-yong-zhe-tiao-kuan'
                }, {
                    title: '隱私權政策',
                    path: 'https://revx.gitbook.io/guide-book/yin-si-quan-zheng-ce'
                },
            ]
        }
    ]

    useEffect(() => {

    }, [])
    return (
        <footer>
            <div className="footer-wrapper sm:flex-row">
                <div className="revx-logo cursor-pointer">
                    <img src={process.env.PUBLIC_URL + '/img/logo/revX-logo-white.png'} alt='revx logo' onClick={() => navigate('/')} />
                    <div className="social-media">
                        <Link to='https://reurl.cc/4ogAoL' target="_blank" rel='noreferer'>
                            <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/social_media/fb.svg'} />
                        </Link>
                        <Link to='https://www.instagram.com/revx_apam' target="_blank" rel='noreferer'>
                            <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/social_media/instagram.svg'} />
                        </Link>
                        <Link to='https://liff.line.me/1645278921-kWRPP32q/?accountId=614buvhk' target="_blank" rel='noreferer'>
                            <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/social_media/line.svg'} />
                        </Link>
                        {/* <Link to='https://x.com/ThroneofDawn?s=20' target="_blank" rel='noreferer'>
                            <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/social_media/twitterX.svg'} />
                        </Link> */}

                    </div>
                </div>
                <div className="main">
                    {
                        footerList.map((item, index) => {
                            return (
                                <ul key={index} className="sm:m-3">
                                    <h6>{item.title}</h6>
                                    {item.item.map((i, index) => {
                                        return (
                                            <li key={index}>
                                                {
                                                    i.path.includes('http')
                                                        ?
                                                        <Link to={i.path} target="_blank" >{i.title}</Link>
                                                        :
                                                        <Link to={i.path} >{i.title}</Link>
                                                }
                                            </li>
                                        )
                                    })}
                                </ul>
                            )
                        })
                    }
                </div>
            </div>

            <p className="copyright">
                Copyright © 2022-2024 APAM. All Rights Reserved.
                <br />
                A member of the APAM . APAM International Co. Ltd
            </p>
        </footer>
    )
}

export default Footer;